export function NullValue() {
  return '-'
}
